export default __webpack_public_path__ + "static/media/park-area.64c36e01.svg";